import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { testId } from 'ui-components/services/testid-service';
import ShipFrom from './ship-from';
import Weight from '../../../fulfillment-planner/weight/weight';
import ShippingService from './shipping-service';
import ConfirmationOption from './confirmation';
import InsuranceOption from './insurance';
import Package from './package';
import { PackageContentDescription } from './package-content-description';
import Size from '../../../fulfillment-planner/dimensions/size';
import Error from '../../../fulfillment-planner/error';
import Presets from '../../../fulfillment-planner/presets/container';
import RateAndCreateLabel from '../../../fulfillment-planner/rate-and-create-label';
import Rate from '../../../fulfillment-planner/rate-consumer';
import DutiesAndTaxes from '../../../fulfillment-planner/duties-and-taxes/with-label';
import ReturnLabelDispatcherContainer from './return-label-dispatcher-container';
import style from './style.module.less';

const sizeAndWeightClassNames = {
  label: style.label,
  'size-input': style['size-input'],
  'weight-input': style['weight-input'],
  weight: style.weight,
  scale: style.scale,
  container: style['size-and-weight-container'],
};

const RateCalcFulfillmentConfiguration = ({
  fulfillmentPlanId,
  returnMetadata = false,
  isQuickshipCompatible = false,
  insuranceProviderName,
  isReturn = false,
}) => {
  const emailAddresses = useMemo(() => {
    return [returnMetadata.emailAddress];
  }, [returnMetadata.emailAddress]);
  return (
    <div {...testId('csw')}>
      {fulfillmentPlanId === 'customers-create-label' && (
        <div className={style['create-label-content-presets']}>
          <Presets fulfillmentPlanId={fulfillmentPlanId} />
        </div>
      )}
      <div className={style['rate-calculator-fulfillment-configuration']}>
        <ShipFrom fulfillmentPlanId={fulfillmentPlanId} isCreatingReturnLabel={!!returnMetadata} />
        <Weight classNames={sizeAndWeightClassNames} showScale shrinkable />
        <ShippingService fulfillmentPlanId={fulfillmentPlanId} />
        <Package />
        <PackageContentDescription />
        <Size classNames={sizeAndWeightClassNames} fulfillmentPlanId={fulfillmentPlanId} shrinkable />
        <ConfirmationOption fulfillmentPlanId={fulfillmentPlanId} />
        <InsuranceOption fulfillmentPlanId={fulfillmentPlanId} />
        <DutiesAndTaxes fulfillmentPlanId={fulfillmentPlanId} />
        <Error className={style['error-container']} />
      </div>
      {!returnMetadata ? (
        <RateAndCreateLabel fulfillmentPlanId={fulfillmentPlanId} hideCostReviewLink isQuickshipCompatible={isQuickshipCompatible} />
      ) : (
        <>
          <div className={style['rate-wrapper']}>
            <Rate />
          </div>
          <div className={style['return-label-dispatcher-wrapper']}>
            <ReturnLabelDispatcherContainer
              emailAddresses={emailAddresses}
              fulfillmentPlanId={fulfillmentPlanId}
              insuranceProviderName={insuranceProviderName}
              isReturn={isReturn}
            />
          </div>
        </>
      )}
    </div>
  );
};

RateCalcFulfillmentConfiguration.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  returnMetadata: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      emailAddress: PropTypes.string,
    }),
  ]),
  isQuickshipCompatible: PropTypes.bool,
  insuranceProviderName: PropTypes.string,
  isReturn: PropTypes.bool,
};

export default RateCalcFulfillmentConfiguration;
